export default function FormatMonths(months) {
    switch(months) {
        case 1:
            return `month`;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
            return `${months} months`;

        case 12:
            return 'year';
    }
}
